import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSearchBoxState } from "../store/searchBoxState/selectors.js";
export const useFareCalendarEligible = () => {
    const searchBoxState = useSelector(getSearchBoxState);
    const searchType = searchBoxState?.type;
    const cabinClass = searchBoxState?.cabinClass;
    const segment = searchBoxState?.searchSegments?.[0];
    const hasSingleValidFrom = segment?.from?.length === 1 && (segment.from[0].type === "CITY" || segment.from[0].type === "AIRPORT");
    const hasSingleValidTo = segment?.to?.length === 1 && (segment.to[0].type === "CITY" || segment.to[0].type === "AIRPORT");
    const areDifferentDestinations = useMemo(() => {
        if (!searchBoxState || !hasSingleValidFrom || !hasSingleValidTo || !segment)
            return false;
        const from = segment.from[0];
        const to = segment.to[0];
        if (from.code === to.code)
            return false;
        if (from.type === "AIRPORT" && to.type === "AIRPORT") {
            if (from.city && to.city && from.city === to.city) {
                return false;
            }
        }
        if (from.type === "CITY" && to.type === "AIRPORT") {
            if (from.code === to.city) {
                return false;
            }
        }
        if (from.type === "AIRPORT" && to.type === "CITY") {
            if (from.city === to.code) {
                return false;
            }
        }
        return true;
    }, [searchBoxState, hasSingleValidFrom, hasSingleValidTo, segment]);
    const isSupportedType = searchType === "ONEWAY";
    const isEconomyClass = cabinClass === "ECONOMY";
    const isFareCalendarEligible = searchBoxState && isSupportedType && areDifferentDestinations && isEconomyClass;
    return !!isFareCalendarEligible;
};
export default useFareCalendarEligible;
